
import { FormattedMessage } from 'react-intl';
import {
  PageHeaderWrapper,
  Button,
  PageHeaderTitle,
  BUTTON_VARIANTS
} from 'cdk-radial';
import {
  StyledButtonContainer,
  StyledHeaderButtonContainer,
  StyledPageHeaderTitle,
  StyledPageHeaderTitleContainer,
  FocusWrapper,
  IconContainer,
  HeaderTitleContainer
} from './styled';
import { useHistory } from 'react-router-dom';
import { URL_ROUTES } from '../../adapters/constants';
import { IconHelp, ICON_SIZE } from 'cdk-radial';


const OrderHeader = (
): JSX.Element => {
  const history = useHistory();

  const handleNavigationClick = () => {
    history.push(URL_ROUTES.newOrderTransmissionPage);
  };

  const handleHelpClick = () => {
    // Safely call WalkMe Player API to open the help menu
    try {
      const api = (window as any).WalkMePlayerAPI;
      if (api?.isMenuOpen && api?.toggleMenu) {
        if (!api.isMenuOpen()) {
          api.toggleMenu();
        }
      }
    } catch (error) {
      // Silently fail if WalkMe API is not available or throws an error
      console.debug('WalkMe Player API error:', error);
    }
  };

  return (
    <PageHeaderWrapper>
      <StyledPageHeaderTitle>
        <StyledPageHeaderTitleContainer>
          <HeaderTitleContainer>
          <PageHeaderTitle>
            <FormattedMessage
              defaultMessage="Transmitted Orders"
              description="Transmitted Orders"
            />
          </PageHeaderTitle>
          <IconContainer onClick={handleHelpClick}>
            <IconHelp size={35} />
          </IconContainer>
          </HeaderTitleContainer>
          <StyledButtonContainer>
            <StyledHeaderButtonContainer>
              <FocusWrapper>
                <Button
                  text={
                    <FormattedMessage
                      defaultMessage="Start New Order Transmission"
                      description="Start New Order Transmission"
                    />
                  }
                  dataTestId="btn-new-order"
                  onClick={handleNavigationClick}
                  variant={BUTTON_VARIANTS.SECONDARY}
                />
              </FocusWrapper>
            </StyledHeaderButtonContainer>
          </StyledButtonContainer>
        </StyledPageHeaderTitleContainer>
      </StyledPageHeaderTitle>

    </PageHeaderWrapper>

  );
};

export default OrderHeader;
